<template>
  <div class="page-loading">
      <loading size="24px" color="#ffffff" vertical>加载中...</loading>
  </div>
</template>

<script>
import { Loading } from 'vant';

export default {
    components:{
        Loading
    }
}
</script>

<style lang="scss" scoped>
.page-loading{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,0.4);
    z-index: 9999;
}
</style>